/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BookingStrictHttpResponse } from '../../booking-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiAdminPingGet$Params {
}

export function apiAdminPingGet(http: HttpClient, rootUrl: string, params?: ApiAdminPingGet$Params, context?: HttpContext): Observable<BookingStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAdminPingGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as BookingStrictHttpResponse<void>;
    })
  );
}

apiAdminPingGet.PATH = '/api/Admin/Ping';
